import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { useState } from 'react';
export function useCollapsibleCategories(categories) {
  const $ = _c(5);
  let t0;
  if ($[0] !== categories) {
    t0 = () => {
      const initialState = {};
      categories.forEach(category => {
        if (category?.id) {
          initialState[category.id] = true;
        }
      });
      return initialState;
    };
    $[0] = categories;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [openCategories, setOpenCategories] = useState(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = categoryId => {
      setOpenCategories(prev => ({
        ...prev,
        [categoryId]: !prev[categoryId]
      }));
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const toggleCategory = t1;
  let t2;
  if ($[3] !== openCategories) {
    t2 = {
      openCategories,
      toggleCategory
    };
    $[3] = openCategories;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}